<template>
    <div class="border-dashed border-100 p-2">
        <div class="formgrid grid ml-1 mb-2">
            <label :for="props.label" class="font-bold">{{ props.label }}: </label>
        </div>
        <div v-if="selectedValue" class="flex flex-column">
            <base-bread-crumb :items="breadcrumbItems" aria-label="breadcrumb" />
            <div class="flex justify-content-between h-2">
                <custom-chip entity="Current Selected" :label="chipLabel" :blue-chip="true" />
            </div>
        </div>
        <div>
            <div v-if="showEntityOptions && selectedValue && !disabled" class="flex justify-content-end mb-2">
                <Button v-if="!showTreeSelect" label="Change" class="p-button p-button-help" @click="toggleTreeSelect(true)" />
                <div v-else class="flex gap-2">
                    <Button v-if="initialLoadedValue !== modelValue" label="Reset Changes" class="p-button p-button-info" @click="resetChanges" />
                    <Button label="Hide Selection" class="p-button p-button-warning" @click="toggleTreeSelect(false)" />
                </div>
            </div>
        </div>
        <!-- <custom-tree-select v-if="props.treeSelectMode" v-model="selectedValue" :label="props.label" :optionsTree="props.optionsTree" :disabled="props.disabled" :showLabel="props.showLabel" /> -->
        <custom-vue-tree-select v-if="showTreeSelect && !disabled" v-model="selectedValue" :label="props.label" :optionsTree="options" @tree-select-changed="emit('tree-select-changed')" :error-message="props.errorMessage" />
    </div>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue';
import { formatChildParentBreadCrumb } from '../../../../../utilities/json-formatter';

const emit = defineEmits(['update:modelValue', 'tree-select-changed']);
const props = defineProps({
    label: {
        type: String,
    },
    modelValue: {
        type: Number,
    },
    options: {
        type: Array,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    showLabel: {
        type: Boolean,
        default: true,
    },
    errorMessage: {
        type: String,
    },
    callBackFunc: {
        type: Function,
    },
    showEntityOptions: {
        type: Boolean,
        default: false,
    },
});

const initialLoadedValue = ref(null);
const breadcrumbItems = ref([]);
const selectedValue = ref(null);
const showTreeSelect = ref(true);
const chipLabel = ref(null);

watch(
    () => props.modelValue,
    () => {
        selectedValue.value = props.modelValue;
    }
);

onMounted(() => {
  if (props.modelValue) {
    initialLoadedValue.value = props.modelValue;
    selectedValue.value = props.modelValue;
  }
});

watch(selectedValue, () => {
    emit('update:modelValue', selectedValue.value);
    loadBreadCrumbs();
});

const loadBreadCrumbs = async () => {
    if (selectedValue.value) {
        const entityDetails = await props.callBackFunc(selectedValue.value);
        chipLabel.value = entityDetails.name;
        breadcrumbItems.value = formatChildParentBreadCrumb(entityDetails);
    }
};

const toggleTreeSelect = (flag) => {
    showTreeSelect.value = flag;
};

const resetChanges = () => {
    selectedValue.value = initialLoadedValue.value;
};
</script>
